import WorkflowStep from "../workflow/workflowStep";
import Guid from "~/helpers/guid";
import Notification from "./notification";
import {NotificationDeliveryMethod} from "../../enums/reminderDeliveryMethod";
import {DurationUnit} from "../../../../common/enums/durationUnit";
import { DefaultEmailStyle } from '~/enums/defaultEmailStyle'

export default class NotificationFactory {
  static create(workflowStep: WorkflowStep) {
    const notification: Notification = new Notification();

    notification.rootModel = workflowStep.rootModel;
    notification.workflowStep = workflowStep;
    notification.defineProperty('client_id', Guid.create());
    notification.defineProperty('trigger_on', Notification.triggerOptions(workflowStep)[0].value.triggerOn);
    notification.defineProperty('target_action_client_id', null);
    notification.defineProperty('subject', '');
    notification.defineProperty('body', '');
    notification.defineProperty('is_after', false);
    notification.defineProperty('relative_to', null);
    notification.defineProperty('relative_amount', 0);
    notification.defineProperty('relative_unit', DurationUnit.hour);
    notification.defineProperty('delivery_methods', [NotificationDeliveryMethod.ViaInSystem]);
    notification.defineProperty<Notification>('email_style', DefaultEmailStyle.Default);

    return notification;
  }
}